/*
 * @Author: zegel
 * @Date: 2020-11-17 10:10:53
 * @LastEditTime: 2020-12-30 17:01:26
 * @LastEditors: Please set LastEditors
 * @Description: 分享页接口
 * @FilePath: /H5/src/projects/scream/services/shareBookPage.ts
 */
import request from 'umi-request'
import { apiUrl, dataReportApiUrl } from '../utils/url'
import { getEnv, isDevelopment } from '@/utils/utils'

interface bookParams {
  id: string
}

export const getBookDataByID = ({ id }: { id: string }) => {
  return request(`${apiUrl}/api/getH5ShareInfo`, {
    method: 'post',
    data: {
      book_id: id
    }
  })
}

interface IReportParams {
  bookId: string
  randomId: string
  action: 1 | 2
  url: string
}

/**
 * 书籍分享页上报
 * 开发环境和randomId不存在(测试环境调试)不上报
 * @description:
 * @param {IReportParams} params
 * @return {*}
 */
export const reportDataFunc = (params: IReportParams) => {
  if (isDevelopment) return
  if (!params.randomId || params.randomId === 'undefined') return
  return request(`${dataReportApiUrl}/api/book/sharedata`, {
    method: 'get',
    params
  })
}

export const getUserData = ({ uid }: { uid: string }) => {
  return request(`${apiUrl}/api/getAuthorPageByH5`, {
    method: 'post',
    data: {
      target_uid: uid
    }
  })
}
